<template>
  <div class="photo-view mach-height max-width" @contextmenu="handleMouse" id="photoBox">
    <div class="photo-view-normal position-relative mach-height">
      <div class="photo-view-tool position-absolute flex flex-row-align-center mach-width">
        <div class="photo-view-changerange flex-center">
          <img class="cursor" src="../../assets/icon-lib-source-photo-b.png" data-tp="larger" @click="sizechange">
          <img class="cursor" src="../../assets/icon-lib-source-photo-s.png" data-tp="smaller" @click="sizechange">
        </div>
        <div class="photo-view-mark flex-center">
          <img class="cursor" src="../../assets/icon-lib-source-mark.png" alt="" @click="showmark">
        </div>
        <div class="photo-view-mark flex-center">
          <img v-if="!isFull" class="cursor" src="../../assets/icon-lib-source-photofull.png" @click="showfull">
          <img v-else class="cursor" src="../../assets/icon-lib-source-unfull.png" @click="exitFull">
        </div>
      </div>
      <!-- <div ref="bigImage" class="photo-view-img flex-center mach-height mach-width" :style="{backgroundImage: 'url('+imgsrc+')',transform: 'scale('+imgdata.scale+')'}"  @mousedown="move"> -->
        <!-- <img :src="imgsrc" :style="{transform: 'scale('+imgdata.scale+')'}"> -->
      <!-- </div> -->
      <div class="photo-view-img-box flex-center mach-height mach-width"  >
        <img class="photo-view-img" ref="bigImage" :src="imgsrc" :style="{backgroundImage: 'url('+imgsrc+')',transform: 'scale('+imgdata.scale+')'}" @mousedown="move">
      </div>
    </div>
  </div>
</template>

<script>
  // document.oncontextmenu = function (e) {
  //           return false;
  //       }
export default {
  name: 'Photoviewer',
  props: {
    imgsrc: {
      required: true,
      type: String
    },
    isFull: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgdata: {
        scale: 1.0
      }
    }
  },
  methods: {

    handleMouse(e) {
      e.preventDefault()
    },
    //图片拖拽
    move(e) {
            e.preventDefault();
            // 获取元素
            var personBox = document.querySelector(".photo-view-img-box");
            var img = document.querySelector(".photo-view-img");
            var x = e.pageX - img.offsetLeft;
            var y = e.pageY - img.offsetTop;
 
            // 添加鼠标移动事件
            personBox.addEventListener("mousemove", move);
            function move(e) {
                img.style.left = e.pageX - x + "px";
                img.style.top = e.pageY - y + "px";
            }
            // 添加鼠标抬起事件，鼠标抬起，将事件移除
            img.addEventListener("mouseup", function () {
                personBox.removeEventListener("mousemove", move);
            });
            // 鼠标离开父级元素，把事件移除
            personBox.addEventListener("mouseout", function () {
                personBox.removeEventListener("mousemove", move);
            });
        },

    sizechange(e) {
      const tp = e.currentTarget.dataset.tp
      if (tp === 'larger') {
        if (this.imgdata.scale >= 2.5) {
          return
        }
        this.imgdata.scale += 0.25
      } else {
        if (this.imgdata.scale <= 0.25) {
          return
        }
        this.imgdata.scale -= 0.25
      }
    },
    showmark() {
      this.$emit('showmark')
    },
    showfull() {
      this.$emit('fullscreen')
    },
    exitFull() {
      this.$emit('fullscreen')
    },
    rollImg(e) {
      /* 获取当前页面的缩放比
            若未设置zoom缩放比，则为默认100%，即1，原图大小
        */
      console.log(e)
      var zoom = parseInt(this.$refs.bigImage.style.zoom) || 100
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom
            wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动
        */
      zoom += e.wheelDelta / 12
      /* 最小范围 和 最大范围 的图片缩放尺度 */
      if (zoom >= 20 && zoom < 250) {
        console.log(zoom)
        this.imgdata.scale = zoom / 100
      }
      return false
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped>
  .photo-view {
    background-color: #191919;
    /* padding: 0 12px; */
    overflow: hidden;
  }

  .photo-view-tool {
    top: 10px;
    height: 30px;
    justify-content: flex-end;
    z-index: 100;
  }

  .photo-view-changerange {
    width: 70px;
    height: 30px;
    border-radius: 15px;
    background-color: #000;
  }

  .photo-view-changerange img {
    margin-right: 4px;
  }

  .photo-view-changerange img:last-child {
    margin: 0;
  }

  .photo-view-mark {
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background-color: #000;
    margin-left: 5px;
  }
/* 
  .photo-view-img img {
    max-width: 100%;
    max-height: 100%;
  } */

  /* .photo-view-img {
    transform: scale(1);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  } */
  .photo-view-img-box{
    max-width: 100%;
    /* max-height: 100%;
    width: 100%;
    height: 100% ; */
    position: absolute;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;


  }
  .photo-view-img {
    max-width: 100%;
    max-height: 100%;
    /* width: 100%; */
    /* height:100% ; */
    /* background-size: contain; */
    position: absolute;
    cursor: move;
    transform: scale(1);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

</style>
